// WEMH Legacy: Alpine-Komponenten (ausgelagert aus Inline-x-data — Shopify-Sanitizer-sicher)
document.addEventListener('alpine:init', () => {
  Alpine.data('wemhSlider', (total) => ({
    current: 0, total: total, autoplay: true, interval: 3000, loop: true,
    timer: null, touchStartX: 0, touchEndX: 0,
    reducedMotion: window.matchMedia('(prefers-reduced-motion: reduce)').matches,
    init() {
      if (this.autoplay && !this.reducedMotion && this.total > 1) this.start();
      const el = this.$el;
      el.addEventListener('mouseenter', () => this.stop());
      el.addEventListener('mouseleave', () => { if (this.autoplay && !this.reducedMotion && this.total > 1) this.start(); });
      el.addEventListener('focusin', () => this.stop());
      el.addEventListener('focusout', () => { if (this.autoplay && !this.reducedMotion && this.total > 1) this.start(); });
      el.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') { e.preventDefault(); this.prev(); }
        if (e.key === 'ArrowRight') { e.preventDefault(); this.next(); }
      });
      el.addEventListener('touchstart', (e) => this.handleTouchStart(e), { passive: true });
      el.addEventListener('touchend', (e) => this.handleTouchEnd(e), { passive: true });
      // Slider-Buttons programmatisch verdrahten: Shopifys Page-Body-Sanitizer entfernt
      // @click-Kurzform aus Page-Bodies (x-on:click überlebt zwar, aber die Handler sind
      // in den Bodies bereits verloren) — empirisch verifiziert 22.07.2026.
      el.querySelectorAll('button').forEach((b) => {
        if (b.dataset.wemhWired) return;
        const cls = b.className || '';
        if (cls.indexOf('left-3') !== -1) { b.addEventListener('click', () => this.prev()); b.dataset.wemhWired = '1'; }
        else if (cls.indexOf('right-3') !== -1) { b.addEventListener('click', () => this.next()); b.dataset.wemhWired = '1'; }
      });
      el.querySelectorAll('button[role="tab"]').forEach((b, i) => {
        if (b.dataset.wemhWired) return;
        b.addEventListener('click', () => this.goTo(i));
        b.dataset.wemhWired = '1';
      });
    },
    start() { this.stop(); this.timer = setInterval(() => this.next(), this.interval); },
    stop() { if (this.timer) { clearInterval(this.timer); this.timer = null; } },
    next() { if (this.current < this.total - 1) this.current++; else if (this.loop) this.current = 0; },
    prev() { if (this.current > 0) this.current--; else if (this.loop) this.current = this.total - 1; },
    goTo(i) { this.current = i; },
    handleTouchStart(e) { this.touchStartX = e.changedTouches[0].screenX; },
    handleTouchEnd(e) {
      this.touchEndX = e.changedTouches[0].screenX;
      const diff = this.touchStartX - this.touchEndX;
      if (Math.abs(diff) > 50) { diff > 0 ? this.next() : this.prev(); }
    },
  }));
});

// Ankaufsrechner: Preise IMMER live aus metal_prices-Metaobject (Formel: (Kurs/g - Abschlag) x Feinheit)
document.addEventListener('alpine:init', () => {
  const r2 = (n) => Math.round(n * 100) / 100;
  Alpine.data('buybackForm', () => ({
    categories: [], activeTab: 0, quantities: {}, phase: 'calculate',
    error: '', loading: false, submitting: false, quote: null, countdown: '',
    contactForm: { customer_name: '', customer_email: '', customer_phone: '', customer_message: '' },
    _timer: null, _validityMin: 15,
    init() {
      try {
        const cfg = JSON.parse(document.getElementById('wemh-buyback-config').textContent);
        this._validityMin = cfg.validity_minutes || 15;
        this.categories = cfg.categories.map(c => ({
          ...c,
          items: c.items.map(it => {
            // Ankaufsbasis = Kurs abzueglich variablem Prozentsatz und festem Betrag je Einheit
            // (beides zentral gepflegt in den Metaobjekten "pricing_group")
            const fixed_once = it.fixed_once ?? 0;
            const basis = (kurs) => Math.max(0, kurs * (1 - (it.percent ?? 0) / 100) - (it.custom_margin ?? 0));
            // Versilberte Ware (Einheit kg): Basis x verguetetes Feinsilber je kg
            if (c.dynamic && it.silver_g_per_kg != null) {
              return { ...it, fixed_once, price_per_unit: r2(basis(cfg.live.silver) * it.silver_g_per_kg) };
            }
            // Massivware (Einheit g): Basis x Feingehalt
            if (c.dynamic) {
              return { ...it, fixed_once, price_per_gram: r2(basis(cfg.live[c.metal]) * it.purity / 1000) };
            }
            return { ...it };
          })
        }));
      } catch (e) { this.error = 'Der Rechner konnte nicht geladen werden. Bitte rufen Sie uns an: 0611 957 697 50.'; }
      if (window.__wemhLeadSuccess) this.phase = 'success';
    },
    key(ci, ii) { return ci + ':' + ii; },
    getQuantity(ci, ii) { return this.quantities[this.key(ci, ii)] ?? ''; },
    setQuantity(ci, ii, v) {
      const n = parseFloat(String(v).replace(',', '.'));
      if (!v || isNaN(n) || n <= 0) delete this.quantities[this.key(ci, ii)];
      else this.quantities[this.key(ci, ii)] = n;
    },
    unitPrice(ci, ii) { const it = this.categories[ci].items[ii]; return it.price_per_gram ?? it.price_per_unit ?? 0; },
    // Positionswert = Menge x Preis je Einheit, abzueglich einmaliger Pauschale (greift nur bei Menge > 0)
    lineTotal(ci, ii) {
      const q = this.quantities[this.key(ci, ii)];
      if (!q) return 0;
      const once = this.categories[ci].items[ii].fixed_once ?? 0;
      return r2(Math.max(0, q * this.unitPrice(ci, ii) - once));
    },
    categoryTotal(ci) { return r2(this.categories[ci].items.reduce((s, _, ii) => s + this.lineTotal(ci, ii), 0)); },
    grandTotal() { return r2(this.categories.reduce((s, _, ci) => s + this.categoryTotal(ci), 0)); },
    hasAnyQuantity() { return Object.keys(this.quantities).length > 0; },
    formatEur(n) { return (Number(n) || 0).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); },
    resetQuantities() { this.quantities = {}; },
    calculateOffer() {
      if (!this.hasAnyQuantity()) return;
      const items = [];
      this.categories.forEach((c, ci) => c.items.forEach((it, ii) => {
        const q = this.quantities[this.key(ci, ii)];
        if (q) items.push({ purity_label: it.label, quantity: q, unit: it.unit,
          price_per_unit: this.unitPrice(ci, ii), line_total: this.lineTotal(ci, ii) });
      }));
      this.quote = { items, total_eur: this.grandTotal(), expires_at: Date.now() + this._validityMin * 60000 };
      this.phase = 'quote';
      this._startCountdown();
    },
    _startCountdown() {
      clearInterval(this._timer);
      const tick = () => {
        const left = Math.max(0, this.quote.expires_at - Date.now());
        const m = Math.floor(left / 60000), s = Math.floor((left % 60000) / 1000);
        this.countdown = String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0');
        if (left <= 0) { clearInterval(this._timer); this.phase = 'expired'; }
      };
      tick(); this._timer = setInterval(tick, 1000);
    },
    showContactForm() { this.phase = 'contact'; },
    // Zurueck zur Eingabe OHNE die Mengen zu verwerfen (Kundenwunsch 09/2026: weitere Artikel
    // ergaenzen, ohne das Angebot komplett neu erfassen zu muessen). resetForm() bleibt der harte Reset.
    addMoreItems() {
      clearInterval(this._timer);
      this.quote = null; this.error = ''; this.phase = 'calculate';
    },
    resetForm() {
      clearInterval(this._timer);
      this.quantities = {}; this.quote = null; this.error = ''; this.phase = 'calculate';
    },
    quoteSummaryText() {
      if (!this.quote) return '';
      const lines = this.quote.items.map(i =>
        i.purity_label + ': ' + this.formatEur(i.quantity) + ' ' + i.unit + ' x ' +
        this.formatEur(i.price_per_unit) + ' EUR/' + i.unit + ' = ' + this.formatEur(i.line_total) + ' EUR');
      lines.push('GESAMTANGEBOT: ' + this.formatEur(this.quote.total_eur) + ' EUR');
      lines.push('Berechnet: ' + new Date().toLocaleString('de-DE') + ' (unverbindliche Preisindikation, Basis tagesaktuelle Kurse; endgueltiger Preis bei Warenpruefung)');
      return lines.join('\n');
    },
    submitRequest() {
      if (!this.contactForm.customer_name || !this.contactForm.customer_email) {
        this.error = 'Bitte Name und E-Mail-Adresse angeben.'; return;
      }
      this.error = '';
      const body = 'ANKAUFSANFRAGE (Online-Rechner)\n' + this.quoteSummaryText() +
        (this.contactForm.customer_message ? '\n\nNachricht: ' + this.contactForm.customer_message : '');
      document.getElementById('wemh-ankauf-body').value = body;
      this.submitting = true;
      // requestSubmit() statt submit(): nur so feuert das submit-Event
      // (Shopify-Pixel form_submitted -> generate_lead). submit() umgeht Event-Handler!
      const f = document.getElementById('wemh-ankauf-form');
      if (f.requestSubmit) f.requestSubmit(); else f.submit();
    },
  }));
});

// Theme-gerenderte Formulare in die Content-Slots der Seiten bewegen
// (Liquid rendert nicht in page.content → Snippet in Section, JS verschiebt es an die richtige Stelle)
(function () {
  const PAIRS = [['wemh-rechner-slot', 'wemh-rechner-src'], ['wemh-kontakt-slot', 'wemh-kontakt-src']];
  const move = () => PAIRS.forEach(([slotId, srcId]) => {
    const slot = document.getElementById(slotId), src = document.getElementById(srcId);
    if (slot && src) { slot.replaceChildren(...src.children); src.remove(); }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', move);
  else move();
})();
